var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"placeholder":_vm.contextualPlaceholder,"highlighted":_vm.field.isHighlighted(),"indicator":_vm.indicator}},[(_vm.field.value())?_c('div',{staticClass:"cell-status",class:_vm.field.value()},[_vm._v(" "+_vm._s(_vm.field.value())+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }